import initTracer from '@media-platform/tracer';
const tracerInit = () => {
    if (TRACER_APP_TOKEN_FRONT) {
        const config = {
            versionName: APP_VERSION,
            appToken: TRACER_APP_TOKEN_FRONT,
        };
        initTracer({ config });
    }
};
export default tracerInit;
